export const createRoutePath = 'create';
export const seeRoutePath = 'see';
export const errorRoutePath = 'error';
